class SubscriptionQuantity extends HTMLElement{
    constructor() {
        super();
    }
        connectedCallback() {
            this.cartDrawer = document.querySelector('cart-drawer');
            this.quantityBundleSubmit = this.querySelector('.quantity-bundle__submit');
            this.mainProductId = this.querySelector("#variant-id").value;
            this.variantBundle = this.hasAttribute("data-variant");
            if (this.quantityBundleSubmit) {
                this.quantityBundleSubmit.addEventListener('click', this.handleAddToCart.bind(this));
            }
            this.purchaseInputs = this.querySelectorAll("quantity-bundle input[name='quantity-bundle']");
            this.initMedia();
            this.purchaseInputs.forEach((purchaseInput)=>{
                    purchaseInput.addEventListener("change", function(e){   
                        const featuredImage = purchaseInput.getAttribute("data-media-id");
                            if(featuredImage){
                                const productMedia = document.querySelector('product-media');
                                        productMedia.setActiveMedia(
                                        parseInt(featuredImage)
                                );
                            }
                    })
                    })
            this.checkDiscount();
        }

        checkDiscount() {
                const variantWrapper = this.querySelector(".subscription-quantity__selector");
                const discountBlock = this.querySelector(".subscription-quantity__discount");
                const discountedPriceBlock = this.querySelector(".price-subscription__discounted");
                const basePrice = parseInt(discountedPriceBlock?.dataset.price ?? "0", 10);
                const pricePerItemBlock = this.querySelector(".subscription-quantity__item-price");
                const pricePerItem = parseInt(pricePerItemBlock?.dataset.price ?? "0", 10);

                const applyState = (checkedVariant, updateQtyLabel = false) => {
                    const qty = parseInt(checkedVariant, 10);
                    const isMulti = Number.isFinite(qty) && qty >= 2;

                    discountBlock?.classList.toggle("discount-active", isMulti);

                    if (discountedPriceBlock) {
                        const multiplier = isMulti ? 0.95 : 1;
                        discountedPriceBlock.innerText = this.formatMoney(basePrice * multiplier);
                    }
                    if (pricePerItemBlock) {
                        const multiplier = isMulti ? 0.95 : 1;
                        pricePerItemBlock.innerText = this.formatMoney(pricePerItem * multiplier);
                    }

                    if (updateQtyLabel) {
                        const qtyContainer = document.querySelector(".subscription-benefits__selected-quantity");
                        if (qtyContainer) qtyContainer.innerText = `${checkedVariant} ${isMulti ? "bags" : "bag"}`;
                    }
                };

                applyState(this.querySelector("input[name='quantity']:checked")?.value);

                variantWrapper?.addEventListener("click", () => {
                    applyState(this.querySelector("input[name='quantity']:checked")?.value, true);
                });
            }

            formatMoney(amountInCents) {
                const amount = Number(amountInCents) / 100;
                const currency = window.Shopify?.currency?.active || 'USD';
                const locale = document.documentElement.lang || 'en';

                try {
                    return new Intl.NumberFormat(locale, {
                        style: 'currency',
                        currency,
                    }).format(amount);
                } catch (e) {
                    return amount.toFixed(2) + ' ' + currency;
                }
            }
                                               
                                

        initMedia(){
            const activeInputId = this.querySelector("subscription-quantity input[name='quantity']:checked")?.getAttribute("data-media-id");
            if(activeInputId){
                const productMedia = document.querySelector('product-media');
                                        productMedia.setActiveMedia(
                                        parseInt(activeInputId)                         
                                );
            }
        }



        async handleAddToCart() {
        const addButton = this.quantityBundleSubmit;
        const loadingOverlay = addButton?.querySelector('.loading-overlay');
        
        if (!addButton || addButton.disabled) return;
    
        addButton.disabled = true;
        loadingOverlay?.classList.remove('hidden');
        try {
            const checkedQuantity = this.querySelector("input[name='quantity']:checked").value;
            // const checkedVariant = this.querySelector("input[name='quantity-bundle']:checked").closest(".quantity-bundle__item");
            const gifts = this.querySelectorAll(".gifts-subscription__item[data-product]");
            // const currentVariantId = checkedVariant.querySelector("#current-variant-id")?.value;
            const sellingPlan = this.querySelector("#subscription-plan")?.value;
            this.cartDrawer = document.querySelector('cart-drawer');
            const formData = new FormData();
            const variantID = this.variantBundle ? currentVariantId : this.mainProductId;
            const quantity = this.variantBundle ? 1 : parseInt(checkedQuantity);
             formData.append("id", variantID);
             formData.append("quantity", quantity);
             sellingPlan ? formData.append("selling_plan", sellingPlan) : null;
            if(gifts && gifts.length>0){
                gifts.forEach((gift, index)=>{
                const variantId = gift.dataset.product;
                formData.append(`items[${index}][id]`, variantId);
                formData.append(`items[${index}][quantity]`, '1');
                })
            }
                if (this.cartDrawer && this.getAttribute("data-checkout") =="false") {
                    const sections = this.cartDrawer.getSectionsToRender?.()?.map(section => section.section);
                        if (sections) {
                            formData.append('sections', sections.join(','));
                        }
                        formData.append('sections_url', window.location.pathname);
                } 
                console.log(...formData)
                // Add items to cart
                const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData
                });

                if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to add items to cart');
                }
                
                const result = await response.json();
                // Update cart drawer if available
                if (this.cartDrawer && result.sections) {
                this.cartDrawer.renderContents(result);
                this.cartDrawer.open();
                }

                // Dispatch cart update event
                document.dispatchEvent(new CustomEvent('cart:updated', { 
                detail: { items: result.items || [] }
                })
            ) 
        
        
        } catch (error) {
            console.error('Error adding items to cart:', error);
        } finally{
             // Hide loading state
            loadingOverlay?.classList.add('hidden');
            addButton.disabled = false;
            if(this.getAttribute("data-checkout") =="true"){
                window.location.href = '/checkout';
            }
        }
    }
}
if (!customElements.get('subscription-quantity')) {
    customElements.define('subscription-quantity', SubscriptionQuantity);
  }



